/* eslint-disable react/prop-types */
import React from 'react';

export const ONSHORE_PRODUCTIVITY_SUMMARY_BADGE_CONFIG = [
  { key: 'totalWelds', label: 'Total welds', tone: 'total' },
  { key: 'acceptedCounts', label: 'Accepted counts', tone: 'accepted' },
  { key: 'rejectedCutout', label: 'Rejected (Cutout)', tone: 'cutout' },
  { key: 'rejectedRepair', label: 'Rejected (Repair)', tone: 'repair' },
];

/** Offshore welding — joint / NDT KPIs (ongoing pipeline). Backend may override computed values. */
export const OFFSHORE_PRODUCTIVITY_SUMMARY_BADGE_CONFIG = [
  { key: 'totalJointsSt1', label: 'Total Joints Station 1', tone: 'total' },
  { key: 'totalJointsAccepted', label: 'Total Joints Accepted', tone: 'accepted' },
  { key: 'totalReweldsSt1', label: 'Rewelds ST1', tone: 'reweld' },
  { key: 'totalNdtRepair', label: 'NDT Repair', tone: 'repair' },
  { key: 'totalNdtCutout', label: 'NDT Cut-out', tone: 'cutout' },
];

/** @deprecated use ONSHORE_PRODUCTIVITY_SUMMARY_BADGE_CONFIG */
export const PRODUCTIVITY_SUMMARY_BADGE_CONFIG = ONSHORE_PRODUCTIVITY_SUMMARY_BADGE_CONFIG;

export const OFFSHORE_SUMMARY_KEYS = OFFSHORE_PRODUCTIVITY_SUMMARY_BADGE_CONFIG.map((c) => c.key);

export const ONSHORE_SUMMARY_KEYS = ONSHORE_PRODUCTIVITY_SUMMARY_BADGE_CONFIG.map((c) => c.key);

export function emptyOffshoreProductivitySummary() {
  return {
    totalJointsSt1: 0,
    totalJointsAccepted: 0,
    totalReweldsSt1: 0,
    totalNdtRepair: 0,
    totalNdtCutout: 0,
  };
}

export function emptyOnshoreProductivitySummary() {
  return {
    totalWelds: 0,
    acceptedCounts: 0,
    rejectedCutout: 0,
    rejectedRepair: 0,
  };
}

export function productivitySummariesEqual(a, b, variant = 'onshore') {
  if (!a && !b) return true;
  if (!a || !b) return false;
  const keys = variant === 'offshore' ? OFFSHORE_SUMMARY_KEYS : ONSHORE_SUMMARY_KEYS;
  return keys.every((key) => (a[key] ?? 0) === (b[key] ?? 0))
    && Boolean(a.isLoading) === Boolean(b.isLoading);
}

const ProductivitySummaryBadges = ({
  summary,
  isLoading = false,
  className = '',
  variant = 'onshore',
}) => {
  const config = variant === 'offshore'
    ? OFFSHORE_PRODUCTIVITY_SUMMARY_BADGE_CONFIG
    : ONSHORE_PRODUCTIVITY_SUMMARY_BADGE_CONFIG;

  return (
    <div
      className={`dpr-productivity-chips ${className}`.trim()}
      aria-label="Productivity summary"
    >
      {config.map(({ key, label, tone }) => {
        const value = summary?.[key];
        const displayValue = isLoading ? '—' : (value != null ? String(value) : '0');
        return (
          <span
            key={key}
            className={`dpr-productivity-chip dpr-productivity-chip--${tone}`}
            title={label}
          >
            <span className="dpr-productivity-chip__label">{label}</span>
            <span className="dpr-productivity-chip__value">{displayValue}</span>
          </span>
        );
      })}
    </div>
  );
};

export default ProductivitySummaryBadges;
